import { takeLatest } from 'redux-saga/effects';
import { DELETE_EVENT_START, UPDATE_EVENT_START } from 'redux/actions/types';
import { removeEventSaga } from './remove-event-saga';
import { updateEventSaga } from './update-event-saga';

export default function* alertsSagas() {
  yield takeLatest(DELETE_EVENT_START, removeEventSaga);
  yield takeLatest(UPDATE_EVENT_START, updateEventSaga);
}
